import { createHttpApiClient } from "./httpClient";
import type { PortalApiClient } from "./PortalApiClient";

export type { PortalApiClient, StaffFolder } from "./PortalApiClient";
export * from "./types";

/**
 * Builds the API client the app should use: the mock client for
 * `npm run dev` with VITE_USE_MOCK_API=true, the real HTTP client
 * otherwise (including every production build). See mockClient.ts.
 *
 * The `import.meta.env.DEV` check is written inline, directly around the
 * dynamic import, on purpose: Vite replaces it with the literal `false`
 * in a production build and its minifier then removes this whole
 * unreachable branch, including the import() call, so mockClient.ts is
 * not present in `npm run build` output. Hiding the check behind a
 * helper function defeats that dead-code elimination (the minifier does
 * not inline across the function boundary), so do not refactor this back
 * into a separate `shouldUseMock()`-style function.
 */
export async function createApiClient(): Promise<PortalApiClient> {
  if (import.meta.env.DEV && import.meta.env.VITE_USE_MOCK_API === "true") {
    const { createMockApiClient } = await import("./mockClient");
    return createMockApiClient();
  }
  return createHttpApiClient();
}
